import React, { Component } from 'react';
import ChatManagement from './ChatManagement';
import Constants from '../../common/constants/Constants';
import Store from '../../redux/Store';
import { showSnackbar } from '../../common/state/snackbar/Snackbar.actions';
import { getChatSessions, logChatAction } from './ChatManagement.actions';
import { connect } from 'react-redux';
import ChatStateEnum from '../../common/constants/ChatStateEnum';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import PageContainer from '../../common/components/Page/PageContainer';

class ChatManagementContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isFetching: false,
    };
  }

  componentDidMount() {
    this.setState({ isFetching: true }, () => this._loadChatSessions());
  }

  render() {
    return (
      <PageContainer pageName="chat-management">
        <PermissionsCheck appliedToPage={true} permission={PermissionsEnum.VIEW_CHAT}>
          <ChatManagement
            onClickOpenSession={this._onClickOpenSession}
            data={this.state}
            isFetching={this.state.isFetching}
          />
        </PermissionsCheck>
      </PageContainer>
    );
  }

  _loadChatSessions = () => {
    getChatSessions()
      .then((res) => {
        this.setState({ data: this._mapChatState(res.body), isFetching: false });
      })
      .catch((res) => {
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to load chat sessions.',
          })
        );
      });
  };

  _onClickOpenSession = (chatSessionLink, correlationId, serialNumber) => {
    var sessionWindow = window.open(chatSessionLink + '&agent=' + this.props.username);
    logChatAction('Chat session opened', correlationId, serialNumber).catch();
    try {
      sessionWindow.focus();

      var interval = setInterval(function () {
        if (sessionWindow.closed) {
          logChatAction('Chat session terminated', correlationId, serialNumber).catch();
          clearInterval(interval);
        }
      }, 1000);
    } catch (e) {
      Store.dispatch(
        showSnackbar({
          type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
          message:
            'New window blocked by browser. Add this site to your exception list and try again.',
        })
      );
    }
  };

  _handlePushMessage = () => {
    const { pushMessage } = this.props;
    let chatSessionList = [];
    if (pushMessage) {
      if (
        this.state.data.find((el) => el.DeviceSerialNumber === pushMessage.data.DeviceSerialNumber)
      ) {
        chatSessionList = this.state.data.filter(function (arrEl, index, arr) {
          if (arrEl.DeviceSerialNumber === pushMessage.data.DeviceSerialNumber) {
            return pushMessage.data; //update with the new information from the event
          } else {
            return arrEl;
          }
        });
      }
    } else {
      chatSessionList = this.state.data;
      chatSessionList.push(pushMessage.data);
    }

    this.setState({ data: this._mapChatState(chatSessionList) });
  };

  _mapChatState = (chatSessionList) => {
    chatSessionList.forEach((el) => {
      el.State = ChatStateEnum.fromValue(el.State).name;
    });
    return chatSessionList;
  };
}

const mapStateToProps = (state, props) => ({
  username: state.user != null ? state.user.User.Username : 'WebUser',
  pushMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'chat_session')
      : null,
});

export default connect(mapStateToProps, {})(ChatManagementContainer);
